import { XGShot } from "./utils";

export function extractShots(status: any): { home: XGShot[]; away: XGShot[] } {
  const out = { home: [] as XGShot[], away: [] as XGShot[] };
  const src = status?.xgmap || status?.c?.xgmap || status?.xg || status?.c?.xg;

  const mapXToHalf = (xRaw: number, team: "home" | "away") => {
    // if feed sends 0..100, normalize back to 0..1
    let nx = xRaw;
    if (typeof nx !== "number" || isNaN(nx)) nx = 0;
    if (nx > 1) nx = nx / 100;
    if (nx < 0) nx = 0;
    if (nx > 1) nx = 1;
    // map into half
    return team === "home" ? nx * 0.5 : 0.5 + nx * 0.5;
  };

  const readSide = (side: any, team: "home" | "away") => {
    if (!Array.isArray(side)) return;
    for (const s of side) {
      const x = s.x ?? s.X;
      const y = s.y ?? s.Y;
      const xg = s.xg ?? s.XG ?? s.val ?? 0;
      const minute = s.min ?? s.minute;
      const sec = s.sec;
      const player = s.player || s.pl || s.p;
      const outcome = s.outcome || s.o;
      const foot = s.foot || s.ft || s.hitType;
      if (typeof x === "number" && typeof y === "number") {
        out[team].push({
          team,
          x: mapXToHalf(x, team),
          y: Math.max(0, Math.min(1, y)),
          xg,
          minute,
          sec,
          player,
          outcome,
          foot,
        });
      }
    }
  };

  if (src) {
    readSide(src.h || src.home, "home");
    readSide(src.a || src.away, "away");
  }

  // mock fallback
  if (out.home.length === 0 && out.away.length === 0) {
    // HOME
    out.home.push({
      team: "home",
      x: mapXToHalf(0.2, "home"),
      y: 0.5,
      xg: 0.42,
      minute: 12,
      sec: 34,
      player: "E.Haaland",
      outcome: "Goal",
      foot: "Right Footed",
    });

    out.home.push({
      team: "home",
      x: mapXToHalf(0.35, "home"),
      y: 0.3,
      xg: 0.18,
      minute: 7,
      sec: 15,
      player: "K.De Bruyne",
      outcome: "On Target",
      foot: "Right Footed",
    });

    out.home.push({
      team: "home",
      x: mapXToHalf(0.62, "home"),
      y: 0.7,
      xg: 0.07,
      minute: 24,
      sec: 49,
      player: "P.Foden",
      outcome: "Off Target",
      foot: "Left Footed",
    });

    out.home.push({
      team: "home",
      x: mapXToHalf(0.12, "home"),
      y: 0.4,
      xg: 0.1,
      minute: 38,
      sec: 5,
      player: "R.Mahrez",
      outcome: "On Target",
      foot: "Left Footed",
    });

    out.home.push({
      team: "home",
      x: mapXToHalf(0.78, "home"),
      y: 0.55,
      xg: 0.29,
      minute: 56,
      sec: 41,
      player: "J.Álvarez",
      outcome: "Off Target",
      foot: "Right Footed",
    });

    // AWAY
    out.away.push({
      team: "away",
      x: mapXToHalf(0.6, "away"),
      y: 0.45,
      xg: 0.15,
      minute: 19,
      sec: 22,
      player: "Messi",
      outcome: "On Target",
      foot: "Left Footed",
    });

    out.away.push({
      team: "away",
      x: mapXToHalf(0.7, "away"),
      y: 0.35,
      xg: 0.05,
      minute: 33,
      sec: 9,
      player: "L.Suárez",
      outcome: "Off Target",
      foot: "Right Footed",
    });

    out.away.push({
      team: "away",
      x: mapXToHalf(0.92, "away"),
      y: 0.6,
      xg: 0.38,
      minute: 71,
      sec: 28,
      player: "Neymar",
      outcome: "On Target",
      foot: "Right Footed",
    });
  }

  return out;
}

export const isSameShot = (a?: XGShot | null, b?: XGShot | null) => {
  if (!a || !b) return false;
  const eps = 1e-6;
  return (
    a.team === b.team &&
    Math.abs(a.x - b.x) < eps &&
    Math.abs(a.y - b.y) < eps &&
    (a.minute ?? -1) === (b.minute ?? -1) &&
    (a.sec ?? -1) === (b.sec ?? -1) &&
    (a.player || "") === (b.player || "") &&
    (a.outcome || "") === (b.outcome || "") &&
    (a.foot || "") === (b.foot || "")
  );
};
